var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tour_sub_wrap"},[_c('iframe',{attrs:{"src":"https://m.blog.naver.com/kogasblog/222117489594","frameborder":"0"}})])
}]

export { render, staticRenderFns }